<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <!-- <div class="filter-box">
            <span class="label">订单编号</span>
            <el-input
              v-model="listQuery.no"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">客户单号</span>
            <el-input
              v-model="listQuery.customerNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">公司抬头</span>
            <el-select :filterable="true" v-model="listQuery.titleId" class="filter-item" placeholder="" @keyup.enter="handleFilter" clearable remote :remote-method="getTitleOptionRemote" :size="t('table.btnSize')">
              <el-option
                v-for="item in titleOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div> -->
          <div class="filter-box">
            <span class="label">客户公司</span>
            <el-input
                v-model="listQuery.customerCompany"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
            />
          </div>
          <!-- <div class="filter-box">
            <span class="label">制单人</span>
            <el-input
                v-model="listQuery.originator"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
            />
          </div> -->
          <div class="filter-box">
            <span class="label">开始日期</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">结束日期</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{isFilterCollapse ? '展开' : '收起'}}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')" >
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
        </div>
      </div>
      <TableList
        ref="tableListRef"
        v-loading="listLoading"
        :dataList="list"
        :columnAllData="columnAllData"
        :tableName="TableName"
        :permissionName="permissionName"
        :isShowPagination="false"
        :canRefresh="false"
        :canChangeColumn="false"
        :highlightCurrentRow="true"
        @command-change="handleCommand"
      >
        <template v-slot:operation-action="scope">
          <el-link
            v-permission="{ pkey: `${permissionName}_APPROVAL` }"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('edit', scope.row)"
          >
            审批
          </el-link>
        </template>
      </TableList>
      <el-pagination
        class="mt-20"
        v-show="total > 0"
        :total="total"
        v-model:currentPage="listQuery.page"
        :page-size="listQuery.size"
        :page-sizes="pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next"
      />
    </div>
    <div v-if="dialogFormVisible" class="approval-order-detail">
      <div style="display:flex;padding-top:20px;gap:20px">
        <FormComponent
          :id="activeId"
          :fromFieldData="originFromFieldData"
          :compareData="targetFromFieldData"
          approvalTitle="原订单内容"
          :dialogFormVisible="dialogFormVisible"
          :api="api"
          :isShowCloseBtn="false"
          :isShowSubmitBtn="false"
          mode="approval"
          :formDisabled="true"
        />
        <FormComponent
          :id="activeId"
          style="margin-left:0px"
          :fromFieldData="targetFromFieldData"
          :compareData="originFromFieldData"
          approvalTitle="修改后新内容"
          :dialogFormVisible="dialogFormVisible"
          :api="api"
          :isShowCloseBtn="false"
          :isShowSubmitBtn="false"
          mode="approval"
          :formDisabled="true"
        />
      </div>
      <template v-if="changeList.length">
        <h4>修改的业务</h4>
        <TableList
          :dataList="changeList"
          :columnAllData="businessColumnAllData.filter(kk => !kk.visible || kk.visible({ newPrice: true }))"
          :showSelection="false"
          :canCommand="false"
          :canChangeColumn="false"
          :isShowPagination="false"
        >
          <template v-slot:no="{ row }">
            <el-tag v-if="isPriceChanged(row)" type="danger" size="small" class="mr-5">改价</el-tag>
            <span :class="{ 'diff-price-new': isPriceChanged(row) }">{{ row.no }}</span>
          </template>
          <template v-slot:price="{ row }">
            <span :class="{ 'diff-price-old': isPriceChanged(row) }">{{ formatCurrency(row.price) }}</span>
          </template>
          <template v-slot:newPrice="{ row }">
            <span :class="{ 'diff-price-new': isPriceChanged(row) }">{{ formatCurrency(row.newPrice) }}</span>
          </template>
        </TableList>
      </template>
      <template v-if="addList.length">
        <h4 class="diff-section-title">新增的业务</h4>
        <TableList
          :dataList="addList"
          :columnAllData="businessColumnAllData.filter(kk => !kk.visible || kk.visible({ newPrice: false }))"
          :tableRowClassName="() => 'approval-row-added'"
          :showSelection="false"
          :canCommand="false"
          :canChangeColumn="false"
          :isShowPagination="false"
        >
          <template v-slot:no="{ row }">
            <el-tag type="danger" size="small" class="mr-5">新增</el-tag>
            <span>{{ row.no }}</span>
          </template>
        </TableList>
      </template>
      <template v-if="removeList.length">
        <h4 class="diff-section-title">删除的业务</h4>
        <TableList
          :dataList="removeList"
          :columnAllData="businessColumnAllData.filter(kk => !kk.visible || kk.visible({ newPrice: false }))"
          :tableRowClassName="() => 'approval-row-removed'"
          :showSelection="false"
          :canCommand="false"
          :canChangeColumn="false"
          :isShowPagination="false"
        >
          <template v-slot:no="{ row }">
            <el-tag type="danger" size="small" class="mr-5 diff-no-strike">删除</el-tag>
            <span>{{ row.no }}</span>
          </template>
        </TableList>
      </template>
      <div class="dialog-footer mt-20">
        <el-button @click="dialogFormVisible = false" >
          {{ t("table.cancel") }}
        </el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="handleSubmit('approve')"
        >
          通过
        </el-button>
        <el-button
          type="danger"
          :loading="submitLoading"
          @click="handleSubmit('reject')"
        >
          拒绝
        </el-button>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import { reviewApprove, reviewReject } from '@/apis/order'
import { getDropdown } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'

import { CostModel, ArrayRowsItem } from '@/model/Index'

import FormComponent from '@/views/order/From.vue'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { TableField } from '@/views/order/FieldTable'
import { businessColumnData } from './businessColumnData'
import { pageVo, pageSizes } from '@/utils/index'
import { formatCurrency } from '@/utils/formatters'
import { isPriceChanged } from '@/utils/approvalDiff'
import { debounce } from 'lodash'
import mixin from '@/mixins/index'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Approvaorder',
  components: {
    FormComponent,
    TableList
  },
  setup() {
    const { t } = useI18n()
    const tableListRef = ref(null)
    const dataMap = reactive({
      TableName: TableName.TABLE_APPROVAL_ORDER,
      permissionName: permissionName.APPROVAL_ORDER,
      columnAllData: [
        ...TableField,
        {
          componentType: 'el-input',
          componentName: '输入框',
          fieldKey: 'updateTime',
          fieldName: '申请时间',
          width: 160
        }
      ],
      businessColumnAllData: businessColumnData,
      isPriceChanged,
      formatCurrency,

      api: 'order',
      originFromFieldData: null,
      targetFromFieldData: null,

      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        no: undefined,
        customerNo: undefined,
        titleId: undefined,
        customerCompany: undefined,
        originator: undefined,
        startTime: undefined,
        endTime: undefined,
        ...pageVo

      },
      pageSizes,
      dialogFormVisible: false,

      salesManOption: [],
      submitLoading: false,
      titleOption: [],
      changeList: [],
      addList: [],
      removeList: [],
      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableListRef.value as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
        }
      },
      getList() {
        dataMap.listLoading = true
        getUrlList('order/page?changeStatus=1', dataMap.listQuery).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.total = res.total
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          no: undefined,
          customerNo: undefined,
          titleId: undefined,
          customerCompany: undefined,
          originator: undefined,
          startTime: undefined,
          endTime: undefined,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },

      handleUpdate(row: any) {
        getUrlList(`order/review/${row.id}`).then((res: any) => {
          dataMap.targetFromFieldData = res.target
          dataMap.originFromFieldData = res.origin
          dataMap.changeList = res.changeList || []
          dataMap.addList = res.addList || []
          dataMap.removeList = res.removeList || []
          dataMap.activeId = row.id
          dataMap.dialogFormVisible = true
        })
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      loadDropdownList(url: string) {
        getDropdown(url).then((res: any) => {
          dataMap[`${url}Option`] = res
        })
      },
      async handleSubmit(type: string) {
        try {
          if (type === 'reject') {
            ElMessageBox.prompt('请输入原因', '提示', {
              confirmButtonText: '提交',
              cancelButtonText: '取消',
              cancelButtonClass: 'el-button--danger'
            }).then(async(content: any) => {
              if (content.action === 'confirm') {
                await reviewReject(dataMap.activeId, { comment: content.value })
                dataMap.dialogFormVisible = false
                dataMap.getList()
                ElMessage.success('操作成功！')
              }
            })
          } else if (type === 'approve') {
            await reviewApprove(dataMap.activeId)
            dataMap.dialogFormVisible = false
            dataMap.getList()
            ElMessage.success('操作成功！')
          }
        } catch (err:any) {
          console.log(err, 'err')
        }
      },
      getTitleOptionRemote: debounce((query: string | number) => {
        getUrlList(`ticketTitle/dropdown?name=${query}`).then((res: any) => {
          dataMap.titleOption = res || []
        })
      }, 500)
    })
    const { mixinData } = mixin(dataMap)
    onMounted(async() => {
      dataMap.getList()
      dataMap.getTitleOptionRemote('')
    })
    return { t, ...toRefs(dataMap), ...toRefs(mixinData), tableListRef }
  }
})
</script>
<style  lang="scss" scope>
.statusStyle{
  .status{
    // border: 1px solid;
    padding: 0 4px;
    border-radius: 6px;
    margin-right: 7px;
    font-size: 10px;
    color:#fff;
  }
}
.redStatusStyle{
  .icon-tubiao-40{
    color:#E74228;
  }
  .status{
    background-color:#E74228;
  }
}
.yellowStatusStyle{
  .icon-tubiao-40{
    color:#F3D03C;
  }
  .status{
    background-color:#F3D03C;
  }
}

.mr-5 {
  margin-right: 6px;
}

.diff-section-title {
  color: #E74228;
  font-weight: 700;
}

.diff-price-old {
  color: #E74228;
  font-weight: 700;
  text-decoration: line-through;
}

.diff-price-new {
  color: #E74228;
  font-weight: 700;
}

.approval-order-detail {
  :deep(.el-table .approval-row-added) {
    color: #E74228 !important;
    font-weight: 600;
    td.el-table__cell {
      color: #E74228 !important;
      background-color: rgba(231, 66, 40, 0.05) !important;
    }
  }
  :deep(.el-table .approval-row-removed) {
    color: #E74228 !important;
    text-decoration: line-through;
    td.el-table__cell {
      color: #E74228 !important;
      text-decoration: line-through;
      background-color: rgba(231, 66, 40, 0.05) !important;
    }
    .diff-no-strike {
      text-decoration: none;
      display: inline-flex;
    }
  }
}
</style>
